import { HttpParams } from "@angular/common/http";

export class ReconciliarLancamentosRequest {

  constructor(
    public contaBancoId: number,
    public dataInicial: string,
    public dataFinal: string
  ) {}

  public toHttpParams(): HttpParams {
    return new HttpParams()
      .set('contaBancoId', this.contaBancoId.toString())
      .set('dataInicial', this.dataInicial)
      .set('dataFinal', this.dataFinal);
  }
}